import {Injectable} from '@angular/core';
import {of} from 'rxjs';
import * as dateFns from 'date-fns';

@Injectable()
export class EventRepository {
    TODAY_STR = new Date().toISOString().replace(/T.*$/, ''); // YYYY-MM-DD of today
    TOMORROW_STR = dateFns.addDays(new Date(), 1).toISOString().replace(/T.*$/, ''); // YYYY-MM-DD of today


    constructor() {
    }

    listPartners() {
        return of([
            {
                id: 123,
                name: 'Teszt Tanya',
                email: 'Teszt_Tanya@gmail.com',
                value: 123
            },
            {
                id: 234,
                name: 'Konyha KFT.',
                email: 'teszt@email.hu'
            },
            {
                id: 345,
                name: 'Adományok.hu',
                email: 'teszt@email.hu'
            }
        ] as {id: number, name: string, email: string}[])
    }

    listActivities() {
        return of([
            {name: 'Tanyalátogatás', id: 0, description: 'Teszt1', canPartTime: true, length: 5, partnerClient: {
                    id: 123,
                    name: 'Teszt Tanya',
                    email: 'Teszt_Tanya@gmail.com',
                },
                categories: [
                    {id: 1, name: 'Fizikai munka'}
                ]
            },
            {name: 'Élelmiszermentés', id: 1, description: 'Teszt2', canPartTime: true, length: 5, partnerClient: {
                    id: 234,
                    name: 'Konyha KFT.',
                    email: 'teszt@email.hu',
                },
                categories: [
                    {name: 'Részidő vállalható', id :2}
                ]
            },
            {name: 'Adományok kezelése', id: 2, description: 'Teszt3', canPartTime: false, length: 5, partnerClient: {
                    id: 345,
                    name: 'Adományok.hu',
                    email: 'teszt@email.hu',
                },
                categories: [
                    {name: 'Hostess munka', id: 3}
                ]
            },
            {name: 'Segítségnyújtás rendezvényeken', id: 3, description: 'Teszt4', canPartTime: false, length: 4.5, partnerClient: 163, categories: []},
        ])
    }

    listEvents(request: any) {
        let events = [
            {
                id: '0',
                title: 'Tanyalátogatás',
                activity: {
                    name: 'Tanyalátogatás',
                    id: 0,
                    description: 'Teszt1',
                    canPartTime: true,
                    length: 5,
                    partnerClient: {
                        id: 123,
                        name: 'Teszt Tanya',
                        email: 'Teszt_Tanya@gmail.com',
                    }
                },
                start: this.TODAY_STR + 'T18:00:00',
                end: this.TODAY_STR + 'T19:00:00',
                address: '4225 nagyonhosszúvárosnév nagyonhosszúutcanév 25/c d 12'
            },
            {
                id: '9',
                title: 'Tanyalátogatás',
                activity: {
                    name: 'Tanyalátogatás',
                    id: 0,
                    description: 'Teszt1',
                    canPartTime: true,
                    length: 5,
                    partnerClient: {
                        id: 123,
                        name: 'Teszt Tanya',
                        email: 'Teszt_Tanya@gmail.com',
                    }
                },
                start: this.TODAY_STR + 'T10:00:00',
                end: this.TODAY_STR + 'T11:00:00',
                address: '4225 nagyonhosszúvárosnév nagyonhosszúutcanév 25/c d 1'
            },
            {
                id: '10',
                title: 'Tanyalátogatás',
                activity: {
                    name: 'Tanyalátogatás',
                    id: 0,
                    description: 'Teszt1',
                    canPartTime: true,
                    length: 5,
                    partnerClient: {
                        id: 123,
                        name: 'Teszt Tanya',
                        email: 'Teszt_Tanya@gmail.com',
                    }
                },
                start: this.TOMORROW_STR + 'T18:00:00',
                end: this.TOMORROW_STR + 'T19:00:00',
                address: '4225 nagyonhosszúvárosnév nagyonhosszúutcanév 25/c d 1'
            },
            {
                id: '1',
                title: 'Élelmiszermentés',
                backgroundColor: 'red',
                activity: {name: 'Élelmiszermentés',
                    id: 1,
                    description: 'Teszt2',
                    canPartTime: true,
                    length: 5,
                    partnerClient: {
                        id: 234,
                        name: 'Konyha KFT.',
                        email: 'teszt@email.hu'
                    }
                },
                start: this.TODAY_STR + 'T00:00:00',
                end: this.TODAY_STR + 'T03:00:00',
                address: '4225 nagyonhosszúvárosnév nagyonhosszúutcanév 25/c d 1'
            },
            {
                id: '2',
                title: 'Adományok kezelése',
                activity: {
                    name: 'Adományok kezelése', id: 2, description: 'Teszt3', canPartTime: false, length: 5, partnerClient: {
                        id: 345,
                        name: 'Adományok.hu',
                        email: 'teszt@email.hu'
                    }
                },
                start: this.TODAY_STR + 'T12:00:00',
                end: this.TODAY_STR + 'T15:00:00',
                address: '4225 nagyonhosszúvárosnév nagyonhosszúutcanév 25/c d 1'
            }
        ]
        if (request !== null) {
            events = events.filter(event => event.activity.id === request)
        }
        return of(events as any[]);
    }

    listApplications() {
        const arr = [
            {
                id: 1,
                event: {
                    id: '0',
                    title: 'Tanyalátogatás',
                    activity: {
                        name: 'Tanyalátogatás',
                        id: 0,
                        description: 'Teszt1',
                        canPartTime: true,
                        length: 5,
                        partnerClient: {
                            id: 123,
                            name: 'Teszt Tanya',
                            email: 'Teszt_Tanya@gmail.com',
                        }
                    },
                    start: this.TODAY_STR + 'T18:00:00',
                    end: this.TODAY_STR + 'T19:00:00',
                    address: '4225 nagyonhosszúvárosnév nagyonhosszúutcanév 25/c d 12'
                },
                user: {
                    id: 1,
                    name: 'Kiss János'
                },
                partTime: false,
                completed: true
            },
            {
                id: 2,
                event: {
                    id: '1',
                    title: 'Élelmiszermentés',
                    backgroundColor: 'red',
                    activity: {name: 'Élelmiszermentés',
                        id: 1,
                        description: 'Teszt2',
                        canPartTime: true,
                        length: 5,
                        partnerClient: {
                            id: 234,
                            name: 'Konyha KFT.',
                            email: 'teszt@email.hu'
                        }
                    },
                    start: this.TODAY_STR + 'T00:00:00',
                    end: this.TODAY_STR + 'T03:00:00',
                    address: '4225 nagyonhosszúvárosnév nagyonhosszúutcanév 25/c d 1'
                },
                user: {
                    id: 1,
                    name: 'Kiss János'
                },
                partTime: false,
                completed: false
            }
        ]
        return of(arr.concat(arr).concat(arr))
    }
}
